<template>
  <div class="container">
    <div class="subject-details" v-if="name === 'tjx'">
      <tjx @applyLink="applyLink"></tjx>
    </div>
    <div class="subject-details" v-else-if="name === 'bjx'">
      <bjx @applyLink="applyLink"></bjx>
    </div>
    <!-- <div class="subject-details" v-else-if="name==='xcb'">
            <xcb @applyLink="applyLink"></xcb>
        </div> -->
    <cube-popup type="my-popup" ref="card-Popup">
      <div class="card-modal-frames">
        <img :src="currentModals" />
        <i class="card-icon-close close-btn close-icon" @click="closePopup"></i>
        <!-- <a
          href="javascript:;"
          @click="(e) => this.routerPush('/map')"
          class="see-net"
        ></a> -->
      </div>
    </cube-popup>
  </div>
</template>
<script>
import tjx from "./tjx/index";
import bjx from "./bjx/index";
// import xcb from "./xcb/index";

export default {
  data() {
    return {
      name: "",
      applyData: {},
      currentModals: "",
      modals: {
        bjx: require("@/assets/images/bjx-modal@2x.png"),
        tjx: require("@/assets/images/tjx-modal@2x.png"),
      },
    };
  },
  components: {
    tjx,
    bjx,
    // xcb
  },
  mounted() {
    this.name = this.$route.params.name;
    this.applyData = this.$store.state.data[this.name]["apply"] || {};
  },
  methods: {
    showPopup(refId) {
      const component = this.$refs[refId];
      component.show();
    },
    applyLink() {
      this.$test(this.applyData.test);
      if (this.applyData.type == "out") {
        window.location.href = this.applyData.url;
      } else {
        if (this.applyData.type == "page") {
          this.routerPush(this.applyData.url);
        } else {
          this.currentModals = this.modals[this.applyData.url];
          this.showPopup("card-Popup");
        }
      }
    },
    routerPush(path, cb) {
      if (typeof path === "string") {
        this.$router.push(path, () => {
          cb && cb();
        });
      } else {
        this.$router.push({
          name: path.path,
          params: { name: path.name },
        });
      }
    },
    hidePopup(refId) {
      const component = this.$refs[refId];
      component.hide();
    },
    closePopup() {
      this.hidePopup("card-Popup");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>